import { render } from "./component-kazn.vue?vue&type=template&id=3e823237"
import script from "./component-kazn.vue?vue&type=script&setup=true&lang=js"
export * from "./component-kazn.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-kazn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e823237"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e823237', __exports__)) {
    api.reload('3e823237', __exports__)
  }
  
  module.hot.accept("./component-kazn.vue?vue&type=template&id=3e823237", () => {
    api.rerender('3e823237', render)
  })

}


export default __exports__